import React from "react";
import { Contact, Header, Hire } from "./Components";

const NERServices = () => {
  return (
    <div className="servicesPages">
      <Header
        header="Access NER Services for Career Growth in Engineering"
        desc="Unlock new opportunities in the engineering sector with NER services. The National Engineering Register (NER) establishes a standardized registration framework for engineering professionals, technologists, and associates across Australia's private and public sectors."
      />
      <div className="body">
        <div>
          <div className="header">What is National Engineering Registration (NER)?</div>
          <div className="desc">
            The National Engineering Register (NER) is a platform introduced by Engineers Australia in 2015 to recognize engineers who meet industry-specific skills,
            qualifications, and professional standards. It serves as a comprehensive resource for identifying engineering professionals who demonstrate high levels of competency
            and professionalism.
          </div>
          <div className="desc">
            The NER provides a standardized framework for registration across both the private and public sectors in Australia, catering to engineering professionals,
            technologists, and associates. It is an essential tool for ensuring industry-wide recognition and credibility.
          </div>
          <div className="desc">
            As one of Engineers Australia's most valuable resources, the NER is an ideal platform for engineering professionals to showcase their expertise, enhance their
            credibility, and explore new opportunities within the Australian engineering industry.
          </div>
          <div className="header">Why Should I Seek Registration in the NER as a Practicing Engineer in Australia?</div>
          <div className="desc">
            The National Engineering Register (NER) serves as a prestigious platform for capable and talented engineers to gain recognition and status within the engineering
            community. As a publicly searchable database, the NER allows individuals and businesses to easily find qualified engineers endorsed by Engineers Australia, the
            country’s peak engineering body.
          </div>
          <div className="desc">
            By registering in the NER, you increase your visibility in the engineering field, as potential employers can discover your profile through the database. This
            recognition as a skilled and qualified engineer provides you with a competitive edge, enhancing your opportunities to be hired for projects or business roles in
            Australia.
          </div>
          <div className="header">Eligibility to Join the NER</div>
          <div className="desc">
            The National Engineering Register (NER) recognizes engineers who demonstrate high levels of expertise, qualifications, and professionalism in their field. Joining the
            NER provides access to numerous reputable employers and companies, enhancing your professional opportunities.
          </div>
          <div className="desc">
            Both members and non-members of Engineers Australia (EA) are eligible to apply for the NER credential, provided they meet specific criteria. To be eligible, you must:
            <ul>
              <li>
                Hold an engineering qualification recognized by Engineers Australia, or have successfully passed the EA migration skills assessment or membership competency
                assessment.
              </li>
              <li>
                Have a minimum of five years of engineering work experience within the last ten years, including at least four years of full-time post-graduate experience
                equivalent to your engineering work.
              </li>
              <li>Fulfill all the requirements of your occupational category for independent practice.</li>
            </ul>
          </div>
        </div>
      </div>
      <Contact />
      <Hire />
    </div>
  );
};

export default NERServices;
